import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShipstationService implements OnDestroy{
  private destroy$ = new Subject<void>();
  private baseurl = 'api/shipstation/';

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  options = { headers: this.headers };

  constructor(private http: HttpClient) { }

  getShipstationAccount(name: string = "shipstation") {
    const url = `${this.baseurl}GetShipstaionAccountFromLocal`;
    return this.http.post<any>(url, { name }, this.options);
  }

  create(body: any): Observable<any> {
    const url = `${this.baseurl}AddShipstationAccount`;
    return this.http.post<any>(url, body, this.options);
  }

  remove(name: string = "shipstation"): Observable<any> {
    const url = `${this.baseurl}RemoveShipstationAccount`;
    return this.http.post(url, { name }, this.options);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
